import Vue from 'vue';
import App from './App.vue';
import { router } from "./router";
import axios from 'axios';
import {helper} from './helper' // bu component olarak alta eklenmedi.
import VueApexCharts from 'vue-apexcharts'
import VueSweetalert2 from 'vue-sweetalert2'
//import VueGeolocation from 'vue-browser-geolocation'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCsepcehAiYFvS3qqYmiYcilnfzDSUsHs8',
    v: 'OPTIONAL VERSION NUMBER',
    // libraries: 'places', //// If you need to use place input
  }
});

const options = {
  confirmButtonColor: '#6e45ac',
  cancelButtonColor: '#e18591',
  background: '#2d3035',
  //foreColor:'#fff'
};
Vue.use(VueSweetalert2, options);
Vue.component('apexchart', VueApexCharts)
//Vue.use(VueGeolocation);

const axiosInstance = axios.create({
  baseURL: "http://localhost:3001/"
  //baseURL:"http://api.okumus.net/"
});

Vue.prototype.$axios = axiosInstance;

new Vue({
render: h => h(App), 
 router,axios
}).$mount('#app')

//new Vue({
 // el: '#app',2
 // render: h => h(App),
 // router,axios,Request
//});


// WEBPACK FOOTER //
// ./src/main.js